module.exports = __webpack_public_path__ + "img/xem.f6f2a6e4.svg";